var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.8335C13.75 7.83893 13.3549 6.88511 12.6517 6.18185C11.9484 5.47858 10.9946 5.0835 10 5.0835C9.00544 5.0835 8.05161 5.47858 7.34835 6.18185C6.64509 6.88511 6.25 7.83893 6.25 8.8335C6.25 13.2085 4.375 14.4585 4.375 14.4585H15.625C15.625 14.4585 13.75 13.2085 13.75 8.8335Z",
    stroke: "#28293D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0814 16.125C10.9716 16.3144 10.8138 16.4717 10.6241 16.581C10.4343 16.6903 10.2192 16.7478 10.0002 16.7478C9.78121 16.7478 9.56606 16.6903 9.3763 16.581C9.18654 16.4717 9.02883 16.3144 8.91895 16.125",
    stroke: "#28293D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.75f962508f0d796055937ae044f11f44.svg";
export { ForwardRef as ReactComponent };